import {jsx as _jsx} from "react/jsx-runtime";import {Node} from '@tiptap/core'
import { NodeViewWrapper, ReactNodeViewRenderer} from '@tiptap/react'
import {lazy} from 'react'

import {appendColumn, appendRow, getColumns, getRows} from './data'

const DatabaseView = lazy(() => import(/* webpackChunkName: 'DatabaseView' */ './DatabaseView'))

function Component(props) {
  const {extension} = props

  return (
    _jsx(NodeViewWrapper, { className: "relative overflow-auto" , children: 
      _jsx(DatabaseView, { doc: extension.options.document, userId: extension.options.userId,} )
    })
  )
}





export const Database = Node.create({
  name: 'database',
  onCreate() {
    // Add some initial content to make the first use easier
    const {document, userId} = this.options
    if (getRows(document).length === 0) {
      if (getColumns(document).length === 0) {
        appendColumn(document, {name: 'Text column', type: 'text'})
        appendColumn(document, {name: 'Number column', type: 'number'})
        appendColumn(document, {name: 'Check column', type: 'check'})
      }
      appendRow(document, userId)
    }
  },
  renderHTML() {
    return ['div']
  },
  parseHTML() {
    return [{tag: 'database'}]
  },
  addNodeView() {
    return ReactNodeViewRenderer(Component, {contentDOMElementTag: 'div'})
  }
})
